<a href="#" style="display: none"></a>

<div class="modal-header">
    <h4 class="modal-title">{{'employeeCard_revokeTitle' | translate}}</h4>
</div>

<div class="modal-body">
    <form #form="ngForm">
        <div class="form-field required">
            <label class="form-label">{{'employeeCard_lblRevocationReason' | translate}}</label>
            <div *ngFor="let n of reasons" class="mb-1">
                <app-radio [(ngModel)]="reasonId" [value]="n.Id" name="reason-{{n}}">
                    {{n.Value}}
                </app-radio>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="cancel()" [disabled]="isSaving">{{'cancel' | translate}}</button>

    <button class="btn btn-primary" (click)="submit()" type="button" [disabled]="!reasonId || isSaving">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isSaving"></span>
        {{'continue' | translate}}
    </button>
</div>
